export var VideoCodec;
(function (VideoCodec) {
    VideoCodec["Unknown"] = "Unknown";
    VideoCodec["H264"] = "H264";
    VideoCodec["VP8"] = "VP8";
})(VideoCodec || (VideoCodec = {}));
export class RtcDiagnosis {
    constructor() {
        const configuration = {
            iceServers: [
                { urls: "stun:stun.l.google.com:19302" },
                { urls: "stun:stun.vivox.com:3478" },
                { urls: "stun:stun.vline.com:3478" },
                { urls: "stun:stun.vo.lu:3478" },
                { urls: "stun:stun.vodafone.ro:3478" },
                { urls: "stun:stun.voicetrading.com:3478" }
            ],
            encodedInsertableStreams: true,
            forceEncodedVideoInsertableStreams: true,
        };
        this.peerConnection = new RTCPeerConnection(configuration);
    }
    addTransceivers(audio, video) {
        for (let i = 0; i < audio; i++) {
            this.peerConnection.addTransceiver("audio", { direction: "recvonly" });
        }
        for (let i = 0; i < video; i++) {
            this.peerConnection.addTransceiver("video", { direction: "recvonly" });
        }
    }
    checkUdpSupport(cb, timeout = 10) {
        let timeoutted = false;
        const timeoutHandler = setTimeout(() => {
            cb(new Error("timeout"));
            timeoutted = true;
        }, timeout * 1000);
        this.peerConnection.oniceconnectionstatechange = () => {
            console.debug("ICE connection state:", this.peerConnection.iceConnectionState);
            if (this.peerConnection.iceConnectionState === "connected") {
                timeoutted || cb();
                clearTimeout(timeoutHandler);
            }
        };
    }
    checkRtcConnected(cb, timeout = 10) {
        let timeoutted = false;
        const timeoutHandler = setTimeout(() => {
            cb(new Error("timeout"));
            timeoutted = true;
        }, timeout * 1000);
        let datachannel = this.peerConnection.createDataChannel("datachannel");
        datachannel.onopen = () => {
            timeoutted || cb();
            clearTimeout(timeoutHandler);
        };
    }
    checkSupportedVideoCodec(cb, timeout = 10) {
        let timeoutted = false;
        let unFinishedCodec = [VideoCodec.H264, VideoCodec.VP8];
        const timeoutFunc = () => {
            cb(unFinishedCodec, new Error("timeout"));
            timeoutted = true;
        };
        const timeoutHandler = setTimeout(timeoutFunc, timeout * 1000);
        // Set up event listener to attach remote streamss
        this.peerConnection.ontrack = (event) => {
            if (event.track.kind === "video") {
                console.debug("Received video track:", event.track);
                const stream = event.receiver.createEncodedStreams();
                const trackReadable = stream.readable;
                const reader = trackReadable.getReader();
                reader.read().then((async function processVideo({ done, value }) {
                    if (done) {
                        console.debug("Stream complete");
                        return;
                    }
                    console.debug("Received video chunk:", value.data);
                    let frame = value;
                    const receiveFrame = (codec) => {
                        console.debug(`Received ${codec} frame`);
                        timeoutted || cb([codec]);
                        unFinishedCodec = unFinishedCodec.filter(item => item !== codec);
                        unFinishedCodec.length === 0 && clearTimeout(timeoutHandler);
                    };
                    // @ts-ignore
                    if (frame.getMetadata().mimeType === "video/H264") {
                        receiveFrame(VideoCodec.H264);
                        return;
                        // @ts-ignore
                    }
                    else if (frame.getMetadata().mimeType === "video/VP8") {
                        receiveFrame(VideoCodec.VP8);
                        return;
                    }
                    else {
                        console.debug("Received unknown frame");
                    }
                    await new Promise((resolve) => setTimeout(resolve, 1)); // avoid infinite loop
                    return reader.read().then(processVideo);
                }));
            }
            else if (event.track.kind === "audio" && event.streams[0]) {
                console.debug("Received audio track:", event.track);
            }
        };
    }
    exchangeSdp(cb) {
        setTimeout(() => {
            this.peerConnection.close();
        }, 30000);
        this.peerConnection.createOffer().then(async (offer) => {
            this.peerConnection.setLocalDescription(offer);
            let offerResponse;
            try {
                let req = {
                    videoCodecs: ["video/H264", "video/VP8"],
                    offer: offer
                };
                offerResponse = await fetch("https://diagnostics.agi7.ai/offer", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${RtcDiagnosis.SECRET_KEY}`,
                    },
                    body: JSON.stringify(req),
                });
            }
            catch (error) {
                cb(undefined, error);
                return;
            }
            cb(offerResponse, null);
            if (!offerResponse || !offerResponse.ok) {
                return;
            }
            const answer = await offerResponse.json();
            this.peerConnection.setRemoteDescription(answer);
        }).catch((err) => {
            console.warn("diagnosis error :", err);
        });
    }
}
RtcDiagnosis.SECRET_KEY = "mingVison";
